import Axios from "../../configs/axios.config";

export const createLeaveType = (data) => Axios.post(`/leave-type`, data).then(response=>response.data.data);
export const updateLeaveType = (data, id) => Axios.put(`/leave-type/${id}`, data).then(response=>response.data.data);
export const getLeaveTypeList = (data) => Axios.get('/leave-type', { params: data }).then(response=>response.data);
export const getLeaveTypeDetail = (id) => Axios.get(`/leave-type/${id}`).then(response=>response.data.data);
export const deleteLeaveType = (id) => Axios.delete(`/leave-type/${id}`);
